module.exports = __webpack_public_path__ + "img/pota-video-microsite.c103c5bd.jpg";